import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useOffer, Offer } from './useData';
import {
  moduleConfig,
  offerFormFields,
  offerFormLayout,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  const config = {
    ...moduleConfig,
    fields: offerFormFields,
    formLayout: offerFormLayout,
    getInitialFormData: getInitialFormData as () => Partial<Offer>,
    mapItemToFormData: mapItemToFormData as (item: Offer) => Partial<Offer>,
  };

  return (
    <GenericFormPage<Offer>
      useData={useOffer}
      config={config}
    />
  );
};

export default Form;
export { Form as OfferForm };
